(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/pages/start.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/pages/start.js');

'use strict';

const SearchbarSection = svs.grassroots.components.searchbar_section.SearchbarSection;
const StartInfoSection = svs.grassroots.components.start_info_section.StartInfoSection;
const SelectedReceivers = svs.grassroots.components.SelectedReceivers;
const ReceiverBottomSheet = svs.grassroots.components.receiver.ReceiverBottomSheet;
const About = svs.grassroots.components.About;
const {
  WidgetArea
} = svs.grassroots.utils;
const {
  grassrootsQueryApi
} = svs.grassroots.store;
const {
  useEffect,
  useRef,
  useState
} = React;
const {
  useParams,
  useHistory
} = ReactRouterDOM;
const Start = () => {
  const newsSection = useRef(null);
  const {
    id
  } = useParams();
  const [receiverId, setReceiverId] = useState('');
  const [open, setOpen] = useState(false);
  const [receiver, setReceiver] = useState({});
  const response = grassrootsQueryApi.useFetchReceiverByIdQuery(receiverId, {
    skip: receiverId === ''
  });
  const history = useHistory();
  const onOpenBottomSheetHandler = receiver => {
    setReceiver(receiver);
    setOpen(true);
  };
  const isAuthenticated = () => svs.core.userSession && svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, []);

  useEffect(() => {
    if (id) {
      setReceiverId(id.split('-')[0]);
    }
  }, [id]);

  useEffect(() => {
    if (response.isSuccess && response.data) {
      onOpenBottomSheetHandler(response.data);
    }
  }, [response]);
  const onCloseHandler = () => {
    setOpen(false);
    history.replace('/');
  };
  return React.createElement("div", {
    className: "f-content"
  }, open && React.createElement(ReceiverBottomSheet, {
    close: onCloseHandler,
    open: open,
    receiver: receiver
  }), React.createElement(SearchbarSection, {
    openBottomSheet: onOpenBottomSheetHandler
  }), React.createElement(SelectedReceivers, {
    openBottomSheet: onOpenBottomSheetHandler
  }), (!isAuthenticated() || svs.grassroots_shared_2.data.config.isCorporateSite) && React.createElement(StartInfoSection, {
    newsSection: newsSection
  }), React.createElement("div", {
    className: "widget-area-container"
  }, React.createElement(WidgetArea, {
    areaName: "resultWidgetArea"
  })), React.createElement("div", {
    className: "widget-area-container",
    ref: newsSection
  }, React.createElement("h1", null, svs.grassroots_shared_2.data.config.newsTitle), React.createElement(WidgetArea, {
    areaName: "newsWidgetArea"
  })), React.createElement(About, null));
};
svs.grassroots.pages.Start = Start;

 })(window);